import { Dispatch, SetStateAction } from 'react'

export const modalTimeout = (
  setIsModalOpen: Dispatch<SetStateAction<boolean>>
) => {
  setTimeout(() => setIsModalOpen(false), 5000)
}
